module.exports = __webpack_public_path__ + "static/media/papahead404.022cfed6.svg";